import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import useApiCall from '../../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import CompanySettingsService from '../../../../../services/CompanySettingsService';

interface UseLogoTabI {
  loadPage: () => Promise<void>;
  setupCompany: ({ logo }: { logo: boolean }) => Promise<void>;
  imageFile: string | File | undefined;
}

export default function useLogoTab({ loadPage, imageFile, setupCompany }: UseLogoTabI) {
  const [isUploadingImage, setIsUploadingImage] = useState(false);

  const { userCode, userProfile, companyCode } = useGetGeneralAppData();

  const { apiCall } = useApiCall();

  const uploadImage = useCallback(async () => {
    await setupCompany({ logo: true });

    await apiCall({
      apiToCall: CompanySettingsService.uploadImage,
      queryParams: { codUsu: userCode, perfilUsu: userProfile, codEmpresa: companyCode },
      onStartLoad: () => setIsUploadingImage(true),
      onEndLoad: () => setIsUploadingImage(false),
      catchMessage: 'Não foi possível relizar o upload da logomarca. Por favor, tente novamente',
      reqBody: [{ key: 'file', value: imageFile }],
      actionAfterResponse: async (response) => {
        if (!response.codigo) {
          toast.error('Não foi possível relizar o upload da imagem. Por favor, tente novamente');
          return;
        }
        toast.success('A logomarca foi definida com sucesso!');
        toast.info('Como uma logomarca foi definida, o campo Utiliza logomarca própria na carta? Foi automaticamente definido como Sim.');
        await loadPage();
      }
    });
  }, [apiCall, companyCode, imageFile, loadPage, setupCompany, userCode, userProfile]);

  return { uploadImage, isUploadingImage };
}
